import React from "react";
import type {FunctionComponent} from "react";
import {WhenUser} from "../../../modules/conditional/when-user/WhenUser";

export interface IWhenUserIsMember {
  not?: boolean;
}

export const WhenUserIsMember: FunctionComponent<IWhenUserIsMember> = ({children, not}) => {
  return <WhenUser isMember={!not} >{children}</WhenUser>;
}

